import React, { Component } from 'react';

class Header extends Component {
  render() {
    return (
        <div id="topo" className="col-12 cabecalho">
            <div className="bg-fundo">
                <div className="col-md-12 padding-left-right-0">
                    <div className="titulo">
                        <h1>{this.props.title}</h1>
                        <h4>{this.props.shortTitle}<span> | </span>{this.props.descricao}</h4>
                    </div>

                    <div className="logo-brasao text-right hidden-md hidden-lg">
                        <img alt="Brasão" src={process.env.PUBLIC_URL+"/img/logo_brasao.png"} />
                    </div>

                    <div className="logo text-right hidden-xs d-lg-block">
                        <img alt="Logo" src={process.env.PUBLIC_URL+"/img/logo_gov.png"} />
                    </div>
                </div>
            </div>
        </div>
    );
  }
}

export default Header;
